export default __webpack_public_path__ + "static/media/dtec_Logo.d19ab1f7.svg";